import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {ColumnsType} from "antd/lib/table";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {Modal, Pagination, Table} from "antd";
import {useStore} from "../../store";
import {AtlasEntity} from "../../entity/atlas-entity";
import AtlasDetail from "../atlas/atlas-detail";
import {transaction} from "mobx";


const SearchGlobalPicture: React.FC = () => {
    const {searchGlobal} = useStore();
    const columns: ColumnsType<AtlasEntity> = [
        {
            title: '图谱编号',
            width: 120,
            dataIndex: 'atlasNumber',
            key: 'atlasNumber',
            align: "center"
        },
        {
            title: '采样编号',
            width: 100,
            dataIndex: 'sampleNumber',
            key: 'sampleNumber',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '药材名',
            width: 100,
            dataIndex: 'medicineName',
            key: 'medicineName',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '基原植物',
            width: 100,
            dataIndex: 'originalPlant',
            key: 'originalPlant',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '拉丁名',
            width: 150,
            dataIndex: 'latinName',
            key: 'latinName',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '样品来源',
            width: 90,
            dataIndex: 'sampleSource',
            key: 'sampleSource',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '取样部位',
            width: 70,
            dataIndex: 'smapleLocation',
            key: 'smapleLocation',
            // fixed: 'left',
            align: "center"
        },
        {
            title: '样品提供单位',
            width: 150,
            dataIndex: 'sampleUnit',
            key: 'sampleUnit',
            // fixed: 'left',
            align: "center"
        },
        // {
        //     title: '鉴定人',
        //     width: 100,
        //     dataIndex: 'appraiser',
        //     key: 'appraiser',
        //     align: "center"
        //     // fixed: 'left',
        // },
        // {
        //     title: '责任人',
        //     width: 100,
        //     dataIndex: 'dutyPerson',
        //     key: 'dutyPerson',
        //     align: "center"
        //     // fixed: 'left',
        // },
        {
            title: '序列提交时间',
            width: 150,
            dataIndex: 'sequenceTime',
            key: 'sequenceTime',
            align: "center"
        },
    ];

    const onItemClick = (record:AtlasEntity) =>{
        transaction(() => {
            searchGlobal.atlasDetailModalOpen = true
            searchGlobal.atlasDetail = record
        })
    }

    const onSizeChange = (page:number, pageSize:number) => {
        transaction(() => {
            searchGlobal.atlasPagination.pageNum = page;
            searchGlobal.atlasPagination.pageSize = pageSize
            searchGlobal.queryGlobal("4", page)
        })
    }

    const onClose = () => {
        searchGlobal.atlasDetailModalOpen = false;
    }

    return (<Wrapper>
        <ContentWrapper>
            <Table
                style={{margin: "0px 20px 0 20px"}}
                rowClassName={(type, index, intent) => {
                    return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                }}
                bordered={true}
                columns={columns}
                onRow={(record) => {
                    return {
                        onClick: () => onItemClick(record),
                    }
                }}
                scroll={{x: 1000, y: 480}}
                pagination={false}
                dataSource={searchGlobal.atlasDataSource}
                size={"middle"}
            />
            <Pagination
                total={searchGlobal.atlasPagination.total}
                size={"small"}
                style={{margin: "10px 20px 20px 0", alignSelf: "end"}}
                showQuickJumper={true}
                showSizeChanger={false}
                defaultPageSize={10}
                hideOnSinglePage={true}
                onChange={onSizeChange}
                current={searchGlobal.atlasPagination.pageNum}
            />
        </ContentWrapper>
        <Modal
            open={searchGlobal.atlasDetailModalOpen}
            onCancel={onClose}
            closable={true}
            centered={true}
            destroyOnClose={true}
            footer={null}
            mask={true}
            maskClosable={true}
            width={"1200px"}>
            <AtlasDetail detail={searchGlobal.atlasDetail}/>
        </Modal>
    </Wrapper>);
}
export default observer(SearchGlobalPicture);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;

    .ant-table-wrapper .ant-table-thead > tr > th {
      background: #EFF3F8;
    }

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    flex: 1;
    margin-top: 20px;
    //border-radius: 4px;
    //border: 1px solid #EAEDF7;
    background: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;